import React, {Fragment, useContext, useEffect, useState} from 'react';
import {EuiBadge, EuiButton, EuiEmptyPrompt, EuiInMemoryTable, EuiPanel, EuiSpacer, EuiText} from "@elastic/eui";
import {NavLink} from "react-router-dom";
import {Order} from "../../../app/models/order";
import { Ticket } from '../../../app/models/Ticket';
import { observer } from 'mobx-react-lite';
import {Store} from "../../../app/stores/store-root";

type ListSupportTicketsForAdminProps={
    items : Ticket[],
    onCloseTicket : (ticket:Ticket)=>void
}

const ListSupportTicketsForAdmin = ({items, onCloseTicket}:ListSupportTicketsForAdminProps) => {

    const store = useContext(Store);
    const[submitting, setSubmitting]=useState(false);

    const onClose = (ticket:Ticket)=>{
        setSubmitting(true);
        onCloseTicket(ticket);
        setSubmitting(false);
    }

    const actions: any[] = [
        {
            name: 'Close',
            description: 'Close this support ticket',
            icon: 'check',
            type: 'icon',
            onClick: onClose ,
        }
    ]

    const fields = [
        {
            field: 'Reference',
            name: 'Reference',
            sortable: true,
            truncateText: true,
            render: (reference: string) => {
                return (<NavLink to={`orders/edit/${reference}`}>
                    {reference}
                </NavLink>)
            }
        },
        {
            field: 'TicketType',
            name: 'Type',
            truncateText: true,
            render: (value: any, item: Ticket) => {
                if (value==='0')
                    return "Correction/Change";
                if(value==='1')
                    return "Cancel";
                if(value==='2')
                    return "Unspecified";
            }

        },
        {
            field: 'Note',
            name: 'Note',

        },
        {
            field: 'Status',
            name: 'Status',
            truncateText: true,
            render: (type: any) => {
                if (type === "1")
                    return <EuiBadge color="primary">Closed</EuiBadge>
                if (type === "0")
                    return <EuiBadge color="warning">Open</EuiBadge>
                if (type === "2")
                    return <EuiBadge color="#AAA">Cancelled</EuiBadge>
            }

        },

        {
            field: 'CreatedAt',
            name: 'Created At',
            sortable: true,

        },
        {
            name:'Actions',
            actions
        }
    ]

    const [message, setMessage] = useState(
        <EuiEmptyPrompt
            iconType="editorStrike"
            title={<h2>You have no support tickets</h2>}
            body={
                <Fragment>
                    <p>
                        support tickets need to be dealt with by the <b>admins</b> , please help resolve issues.
                    </p>
                    <p> Please pick the most urgent issue first</p>
                </Fragment>
            }
            actions={
                <EuiButton color="primary" fill>
                    Load orders
                </EuiButton>
            }
        />
    );

    return (
        <EuiPanel paddingSize="l" hasShadow>
            <EuiText>
                <h3>Outstanding Support Tickets</h3>
                <p>
                    This section lists all money transfer orders you have created. You can filter and sort your records by status, user name, and pickup office
                </p>
            </EuiText>
            <EuiSpacer size={"xxl"}/>
            <EuiInMemoryTable
                items={items}
                itemId="Reference"
                hasActions={true}
                columns={fields}
                pagination={true}
                //selection={selectionValue}
                isSelectable={true}
                //search={searchSettings}
                sorting={true}
                message={message}
                loading={submitting}

            />
        </EuiPanel>

    );
};

export default observer(ListSupportTicketsForAdmin);
